/* eslint-disable indent */
import React from 'react'
import { Button, Grid, useMediaQuery } from '@geist-ui/react'

export default function Login() {
  const isSM = useMediaQuery('sm', { match: 'up' })
  const isMD = useMediaQuery('md', { match: 'up' })

  return (
    <>
      <Grid
        direction="row"
        alignItems="center"
        justify="space-between"
        xs={24}
        style={{
          backgroundColor: 'white',
          height: isMD ? 'auto' : 'auto',
          ...(isMD
            ? {}
            : {
                left: 0,
                padding: isSM ? '0 3%' : '0 18px',
                position: 'fixed',
                width: '100%',
                zIndex: 20,
              }),
        }}
      >
        <div>
          <a
            href="https://waterproplan.com"
            style={{
              display: 'block',
              cursor: 'pointer',
              marginTop: '20px',
              marginBottom: '20px',
            }}
          >
            <img
              alt="WaterPro Wordmark Logo"
              style={{ height: isMD ? '70px' : '40px' }}
              src="/images/WaterPro_Logo_Color.png"
            />
          </a>
        </div>
        <a
          title="Link back to WaterPro homepage"
          href="https://waterproplan.com"
        >
          <Button
            className="header-button"
            style={{
              backgroundColor: 'rgb(0, 64, 128)',
              border: 'none',
              color: 'white',
              fontSize: '16px',
              minWidth: '0px',
            }}
            href="https://waterproplan.com"
          >
            Learn More
          </Button>
        </a>
      </Grid>
      {!isMD && (
        <Grid
          xs={24}
          style={{
            height: '64px',
          }}
        />
      )}
    </>
  )
}
